import {routeItems} from "@/router/endpoints";
import {permissions} from "@/router/permissions";

export default [
  {
    path: "/",
    name: "/",
    redirect: "/login",
  },
  {
    path: "/login",
    name: "login",
    component: () => import("./views/account/login"),
    meta: { authPage: true },
  },
  {
    path: "/forgot-password",
    name: "Forgot password",
    component: () => import("./views/account/password-reset-request"),
    meta: { authPage: true },
  },
  {
    path: "/change-password/:token",
    name: "Change password",
    component: () => import("./views/account/password-change"),
    meta: { authPage: true },
  },
  {
    path: "/dashboard",
    name: "dashboard",
    meta: { authRequired: true },
    component: () => import("./views/dashboard"),
  },
  {
    path: "/profile",
    name: "profile",
    meta: { authRequired: true },
    component: () => import("./views/account/profile"),
  },
  {
    path: "/404",
    name: "404",
    component: require("./views/utility/404").default,
  },
  {
    path: "/403",
    name: "403",
    component: require("./views/utility/403").default,
  },
  {
    path: "*",
    redirect: "404",
  },
    // orders
  {
    path: routeItems.create_sample_order_route,
    name: "menuitems.orders.list.create_sample",
    meta: {
      authRequired: true,
      permissions: permissions.create_sample_orders_permissions,
    },
    component: () => import("./views/orders/create-sample-order"),
  },
  {
    path: routeItems.create_order_route,
    name: "menuitems.orders.list.create_order",
    meta: {
      authRequired: true,
      permissions: permissions.create_orders_permissions,
    },
    component: () => import("./views/orders/create-order"),
  },
  {
    path: routeItems.sample_orders_route,
    name: "menuitems.orders.list.sample_orders",
    meta: {
      authRequired: true,
      permissions: permissions.sample_orders_permissions,
    },
    component: () => import("./views/orders/sample-orders"),
  },
  {
    path: routeItems.customer_orders_route,
    name: "menuitems.orders.list.orders",
    meta: {
      authRequired: true,
      permissions: permissions.customer_orders_permissions,
    },
    component: () => import("./views/orders/customer-orders"),
  },
  {
    path: routeItems.single_customer_orders_route+`/:id`, //:id
    name: "single customer order",
    meta: {
      authRequired: true,
      permissions: [permissions.manual_statements_permissions],
    },
    component: () => import("./views/orders/single-customer-orders"),
  },
  {
    path: routeItems.sample_invoice_route+`/:id`, //:id
    name: "sample order invoice",
    meta: {
      authRequired: true,
      permissions: permissions.sample_invoice_permissions,
    },
    component: () => import("./views/orders/sample-invoice"),
  },
  {
    path: routeItems.customer_order_invoice_route+`/:id`, //:id
    name: "customer order invoice",
    meta: {
      authRequired: true,
      permissions: permissions.customer_order_invoice_permissions,
    },
    component: () => import("./views/orders/order-invoice"),
  },
  {
    path: routeItems.customize_order_route+`/:id`, //:id
    name: "customize order",
    meta: {
      authRequired: true,
      permissions: permissions.customize_order_permissions,
    },
    component: () => import("./views/orders/customize-order"),
  },
  {
    path: routeItems.customize_sample_order_route+`/:id`, //:id
    name: "customize sample order",
    meta: {
      authRequired: true,
      permissions: permissions.customize_sample_order_permissions,
    },
    component: () => import("./views/orders/customize-sample-order"),
  },
  {
    path: routeItems.order_detail_route+`/:id/:authToken`,
    name: "order detail",
    component: () => import("./views/orders/order-details")
  },
  {
    path: routeItems.sample_order_detail_route+`/:id/:authToken`,
    name: "sample order detail",
    component: () => import("./views/orders/sample-order-details")
  },


  {
    path: routeItems.scheduled_deliveries_route,
    name: "scheduled deliveries",
    meta: {
      authRequired: true,
      permissions: permissions.scheduled_deliveries_permissions,
    },
    component: () => import("./views/deliveries/scheduled-deliveries"),
  },
  {
    path: routeItems.upcoming_deliveries_route,
    name: "upcoming deliveries",
    meta: {
      authRequired: true,
      permissions: permissions.upcoming_deliveries_permissions,
    },
    component: () => import("./views/deliveries/upcoming-deliveries"),
  },
  {
    path: routeItems.onroute_deliveries_route,
    name: "onroute deliveries",
    meta: {
      authRequired: true,
      permissions: permissions.onroute_deliveries_permissions,
    },
    component: () => import("./views/deliveries/onroute-deliveries"),
  },
  {
    path: routeItems.incomplete_deliveries_route,
    name: "incomplete deliveries",
    meta: {
      authRequired: true,
      permissions: permissions.incomplete_deliveries_permissions,
    },
    component: () => import("./views/deliveries/incomplete-deliveries"),
  },



  {
    path: routeItems.pending_payments_route,
    name: "pending payments",
    meta: {
      authRequired: true,
      permissions: permissions.pending_payments_permissions,
    },
    component: () => import("./views/finance/pending-payments"),
  },
  {
    path: routeItems.processed_payments_route,
    name: "processed payments",
    meta: {
      authRequired: true,
      permissions: permissions.processed_payments_permissions,
    },
    component: () => import("./views/finance/processed-payments"),
  },
  {
    path: routeItems.manual_statements_route,
    name: "manual statements",
    meta: {
      authRequired: true,
      permissions: permissions.manual_statements_permissions,
    },
    component: () => import("./views/finance/manual-statements"),
  },
  {
    path: routeItems.automated_statements_route,
    name: "automated statements",
    meta: {
      authRequired: true,
      permissions: permissions.automated_statements_permissions,
    },
    component: () => import("./views/finance/automated-statements"),
  },
  {
    path: routeItems.statement_logs_route+`/:id`, //:id
    name: "statement logs",
    meta: {
      authRequired: true,
      permissions: ["orders.view_statementemaildetails"],
    },
    component: () => import("./views/finance/statement-logs"),
  },
  {
    path: routeItems.bulk_payment_processing,
    name: "bulk payment processing",
    meta: {
      authRequired: true,
      permissions: ["orders.view_statementemaildetails"],
    },
    component: () => import("./views/finance/bulk-payments-processing"),
  },
  {
    path: routeItems.credit_note_route,
    name: "credit notes",
    meta: {
      authRequired: true,
      permissions: ["orders.add_creditnote"],
    },
    component: () => import("./views/finance/create-credit-note"),
  },
  {
    path: routeItems.single_credit_note_route+`/:id`, //:id
    name: "single credit note",
    meta: {
      authRequired: true,
      permissions: ["orders.view_creditnote"],
    },
    component: () => import("./views/finance/single_credit_note"),
  },


  {
    path: routeItems.warehouses_route,
    name: "warehouses",
    meta: {
      authRequired: true,
      permissions: permissions.warehouses_permissions,
    },
    component: () => import("./views/warehouses/warehouses"),
  },
  {
    path: routeItems.single_warehouse_stock_route+`/:id`, //:id
    name: "single warehouse stock",
    meta: {
      authRequired: true,
      permissions: [permissions.view_single_warehouse_permission],
    },
    component: () => import("./views/warehouses/single-warehouse-stock"),
  },


  {
    path: routeItems.shipments_route,
    name: "shipments",
    meta: {
      authRequired: true,
      permissions: permissions.shipments_permissions,
    },
    component: () => import("./views/shipments/shipments"),
  },
  {
    path: routeItems.record_shipment_route,
    name: "record shipment",
    meta: {
      authRequired: true,
      permissions: permissions.record_shipment_permissions,
    },
    component: () => import("./views/shipments/record-shipment"),
  },


  {
    path: routeItems.stock_route,
    name: "stock",
    meta: {
      authRequired: true,
      permissions: permissions.stock_permissions,
    },
    component: () => import("./views/stock/stock"),
  },
  {
    path: routeItems.adjusted_stock_route,
    name: "adjusted stock",
    meta: {
      authRequired: true,
      permissions: permissions.adjusted_stock_permissions,
    },
    component: () => import("./views/stock/adjusted-stock"),
  },


  {
    path: routeItems.products_route,
    name: "products",
    meta: {
      authRequired: true,
      permissions: permissions.products_permissions,
    },
    component: () => import("./views/products/products"),
  },
  {
    path: routeItems.add_product_route,
    name: "add product",
    meta: {
      authRequired: true,
      permissions: permissions.add_product_permissions,
    },
    component: () => import("./views/products/add-product"),
  },
  {
    path: routeItems.single_product_route+`/:id`, //:id
    name: "single product",
    meta: {
      authRequired: true,
      permissions: [permissions.view_single_product_permission],
    },
    component: () => import("./views/products/single-product"),
  },


  {
    path: routeItems.add_customer_route,
    name: "add customer",
    meta: {
      authRequired: true,
      permissions: permissions.add_customer_permissions,
    },
    component: () => import("./views/customers/add-customers"),
  },
  {
    path: routeItems.all_customers_route,
    name: "all customers",
    meta: {
      authRequired: true,
      permissions: permissions.all_customers_permissions,
    },
    component: () => import("./views/customers/customers"),
  },
  {
    path: routeItems.single_customer_route+`/:id`, //:id
    name: "single customer",
    meta: {
      authRequired: true,
      permissions: ["institution.view_institutions_list", "institution.view_branches_list", "institution.add_branches", "institution.change_branches"],
    },
    component: () => import("./views/customers/single-customer"),
  },
  {
    path: routeItems.single_branch_route+`/:id`, //:id
    name: "single branch",
    meta: {
      authRequired: true,
      permissions: ["institution.view_branches_list", "orders.view_orders_list", "institution.view_contactinformation", "account.view_userprofiles"],
    },
    component: () => import("./views/customers/single-branch"),
  },
  {
    path: routeItems.create_sales_profile_route,
    name: "create sales profile",
    meta: {
      authRequired: true,
      permissions: permissions.create_sales_profile_permissions,
    },
    component: () => import("./views/customers/create-sales-profile"),
  },
  {
    path: routeItems.sales_profile_route,
    name: "sales profiles",
    meta: {
      authRequired: true,
      permissions: permissions.sales_profile_permissions,
    },
    component: () => import("./views/customers/sales-profile"),
  },
  {
    path: routeItems.single_sales_profile_route+`/:id`, //:id
    name: "single sales profile",
    meta: {
      authRequired: true,
      permissions: [permissions.view_single_sales_profile_permission],
    },
    component: () => import("./views/customers/single-sales-profile"),
  },


  {
    path: routeItems.add_staff_route,
    name: "add system users",
    meta: {
      authRequired: true,
      permissions: permissions.add_staff_permissions,
    },
    component: () => import("./views/staff/add-staff"),
  },
  {
    path: routeItems.staff_route,
    name: "system users",
    meta: {
      authRequired: true,
      permissions: permissions.staff_permissions,
    },
    component: () => import("./views/staff/staff"),
  },
  {
    path: routeItems.single_staff_route+`/:id`, //:id
    name: "single system user",
    meta: {
      authRequired: true,
      permissions: ["account.view_users", "account.view_userprofiles", "auth.view_permission", "auth.view_group"],
    },
    component: () => import("./views/staff/single-staff"),
  },



  {
    path: routeItems.user_roles_route,
    name: "user roles",
    meta: {
      authRequired: true,
      permissions: [],
    },
    component: () => import("./views/roles/user-roles"),
  },
  {
    path: routeItems.single_user_role_route+`/:id`, //:id
    name: "single user role",
    meta: {
      authRequired: true,
      permissions: ["auth.view_group", "auth.view_permission", "account.delete_rolepermission"],
    },
    component: () => import("./views/roles/single-user-role"),
  },


  {
    path: routeItems.automated_tasks_route,
    name: "automated tasks",
    meta: {
      authRequired: true,
      permissions: permissions.automated_tasks_permissions,
    },
    component: () => import("./views/settings/automated-tasks"),
  },
  {
    path: routeItems.system_settings_route,
    name: "system settings",
    meta: {
      authRequired: true,
      permissions: permissions.system_settings_permissions,
    },
    component: () => import("./views/settings/system-settings"),
  },
  {
    path: routeItems.user_settings_route,
    name: "user settings",
    meta: {
      authRequired: true,
      permissions: permissions.user_settings_permissions,
    },
    component: () => import("./views/settings/user-settings"),
  },


  {
    path: routeItems.turnover_reports_route,
    name: "turnover reports",
    meta: {
      authRequired: true,
      permissions: [],
    },
    component: () => import("./views/reporting/turnover"),
  },
  {
    path: routeItems.sales_reports_route,
    name: "sales activity reports",
    meta: {
      authRequired: true,
      permissions: [],
    },
    component: () => import("./views/reporting/sales-activity"),
  },
  {
    path: routeItems.orders_and_deliveries_reports_route,
    name: "orders and deliveries reports",
    meta: {
      authRequired: true,
      permissions: [],
    },
    component: () => import("./views/reporting/orders-and-deliveries"),
  },
  {
    path: routeItems.finance_reports_route,
    name: "finance reports",
    meta: {
      authRequired: true,
      permissions: [],
    },
    component: () => import("./views/reporting/finance"),
  },
  {
    path: routeItems.stock_reports_route,
    name: "stock reports",
    meta: {
      authRequired: true,
      permissions: [],
    },
    component: () => import("./views/reporting/stock"),
  },
  {
    path: routeItems.customers_reports_route,
    name: "customers reports",
    meta: {
      authRequired: true,
      permissions: [],
    },
    component: () => import("./views/reporting/customers"),
  },


];
